import tw from "tailwind-styled-components";

export { default as htmlTemplateStyles } from "./HtmlTemplate.module.css";
export { default as reactCropCss } from "./reactCrop.module.css";

export const Button = tw.button`p-2 px-4 border-2 border-gray-400 rounded-md hover:border-green-300 transform active:bg-green-600 active:scale-95 font-semibold`;
